import { http } from '../../../Lib/Http/httpClient';
import { del, set } from '../reducer';
export function getPairs() {
    return function (dispatch) {
        return http.client.get('/pairs', {
            cache: {
                maxAge: 0
            }
        }).then(function (response) {
            dispatch(set(response.data.data));
        });
    };
}
export function getPairsByBrokerId(params) {
    return function (dispatch) {
        return http.client.get('/pairs', {
            params: params,
            cache: {
                maxAge: 0
            }
        }).then(function (response) {
            dispatch(set(response.data.data));
        });
    };
}
export function deletePair(id) {
    return function (dispatch) {
        return http.client.delete('/pairs/' + id, {}).then(function () {
            dispatch(del(id));
        });
    };
}
